<template>
  <section class="join-us-section" :class="ui?.root">
    <UContainer>
      <div
        class="wrapper p-15 max-xl:p-10 max-sm:px-4.75 rounded-[30px]! max-xl:rounded-[24px]!"
        :class="ui?.wrapper"
      >
        <h4 class="title mb-6 max-xl:mb-4" :class="ui?.title">
          Присоединяйтесь к нам
        </h4>
        <p
          class="description mb-10 w-1/2 max-xl:w-5/9 max-lg:w-19/24 max-md:w-full"
          :class="ui?.description"
        >
          Зарегистрируйте свою спортивную школу или федерацию и начните
          управлять контентом уже сегодня
        </p>

        <div
          class="flex items-center gap-3 max-xl:max-w-13/24 max-lg:max-w-full max-md:flex-col"
        >
          <UButton
            class="text-accent-default px-5 max-lg:w-full"
            size="xl"
            color="white"
            @click="schoolRegisterModal.open()"
          >
            Регистрация школы
          </UButton>

          <UButton
            class="text-white ring-white px-5 max-lg:w-full"
            size="xl"
            variant="outline"
          >
            Регистрируюсь как тренер
          </UButton>
        </div>
      </div>
    </UContainer>
  </section>
</template>

<script lang="ts" setup>
import SchoolRegisterModal from '../modals/SchoolRegisterModal.vue'

defineOptions({
  name: 'JoinUsSection',
})

defineProps<{
  ui?: {
    root?: string
    wrapper?: string
    title?: string
    description?: string
  }
}>()

const overlay = useOverlay()
const schoolRegisterModal = overlay.create(SchoolRegisterModal)
</script>

<style lang="scss" scoped>
.wrapper {
  background-image: url(/images/join-us/background.webp);
  background-repeat: no-repeat;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 30px;

  @include isLessThan(lg) {
    background-image:
      linear-gradient(90deg, rgba(1, 35, 80, 0.64) 0%, rgba(1, 35, 80, 0) 100%),
      linear-gradient(
        322.26deg,
        rgba(1, 35, 80, 0.4) 26.78%,
        rgba(1, 35, 80, 0) 58.79%
      ),
      url(/images/join-us/background-768.webp);
    background-size: cover;
    background-position: right;
  }
}

.title {
  color: var(--static-white, #fff);
  font-size: var(--text-size-h2, 34px);
  font-style: normal;
  font-weight: 600;
  line-height: var(--heading-line-height-H2-line-height, 40px); /* 117.647% */
  letter-spacing: var(--heading-letter-spacing-H2-letter-spacing, -0.12px);
}

.description {
  color: var(--static-white, #fff);
  font-size: var(--paragraph-regular-font-size, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--paragraph-regular-line-height, 24px); /* 150% */
  letter-spacing: var(--paragraph-regular-letter-spacing, 0);
}
</style>
